import { action, thunk } from 'easy-peasy'
import { api, Auth } from '../api.js'

const LinkModel = {
  all: null,

  getLinks: thunk(async (actions, payload, helpers) => {
    const { options } = payload

    let headers = Auth.getRequestHeaders()

    let response = await api.post('/link/all', {}, { headers })

    if (!response.data.error) actions.setLinks(response.data.links)

    helpers.getStoreActions().common.processResponse({ response, options })
  }),

  setLinks: action((state, payload) => {
    state.all = payload
  }),

  createLink: thunk(async (actions, payload, helpers) => {
    const { url, options } = payload

    let headers = Auth.getRequestHeaders()

    let response = await api.post('/link/create', { url, days: payload.days }, { headers })

    if (response.data.error) {
      helpers.getStoreActions().common.processResponse({ response })
      if (options.completed) options.completed(null)
    } else {
      options.completed(response.data.short)
    }
  }),

  updateLink: thunk(async (actions, payload, helpers) => {
    const { id, expires, options } = payload

    let headers = Auth.getRequestHeaders()

    let response = await api.post('/link/update', { id, expires }, { headers })

    if (response.data.error) {
      helpers.getStoreActions().common.processResponse({ response })
    }

    if (options?.completed) options.completed(!response.data.error)
  }),

  deleteLink: thunk(async (actions, payload, helpers) => {
    const { id, options } = payload

    let headers = Auth.getRequestHeaders()

    let response = await api.post('/link/delete', { id }, { headers })

    if (response.data.error) {
      helpers.getStoreActions().common.processResponse({ response })
    }

    if (options?.completed) options.completed(!response.data.error)
  })
}

export default LinkModel
